<template>
  <div>
    <div style="text-align:left">
      获取数据：<br />
      openid:{{userInfo.openid}}<br />
      nickname:{{userInfo.nickname}}<br />
      sex:{{userInfo.sex}}<br />
      headimgurl:{{userInfo.headimgurl}}<br />
      privilege:{{userInfo.privilege}}<br />
      unionid:{{userInfo.unionid}}<br />
      扫描结果:{{scanQRCodeValue}}<br />
    </div>
    <van-button @click="scanQRCode" type="primary">扫一扫</van-button>
    <br />
    <van-button @click="detectAuth" type="primary">人脸识别</van-button>
    <van-button @click="getBizToken" type="primary">获取bizToken</van-button>
    <van-button @click="chooseWxPay" type="primary">支付</van-button>
  </div>
</template>
<script>
import { GetQueryString } from '@/assets/js/common.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      scanQRCodeValue: "",
      userInfo: {},
    };
  },
  methods: {
    scanQRCode() {
      let _this = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          _this.scanQRCodeValue = res.resultStr;
          console.log("扫描结果为：" + res.resultStr);
        }
      });
    },
    detectAuth() {
      this.$postQuery('/tencentFaceId/detectAuth', null).then((response) => {
        console.log(response);
        window.location.href = response.obj.url;
        this.$strore.BizToken = response.obj.bizToken;
      })
    },
    getBizToken() {
      alert(this.$store.state.BizToken)
    },
    chooseWxPay() {
      let data = {};
      this.$postQuery('/WeChatPay/createOrder', data).then((response) => {
        console.log(response.obj);
        wx.chooseWXPay({
          timestamp: response.obj.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: response.obj.nonceStr, // 支付签名随机串，不长于 32 位
          package: response.obj.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType:response.obj.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: response.obj.paySign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            console.log(res);
          }
        });
      })
    }
  },
  created: function () {
    console.log("-----------code--------------");
    let code = GetQueryString("code");
    console.log(code);
    let data = {
      code: code
    }
    this.$postQuery('/WeChat/getUserInfo', data).then((response) => {
      this.userInfo = response.obj;
      console.log(this.userInfo)
    })
  }
};
</script>>